<template>
  <div v-if="!loading" class="flex flex-col">
    <h2>Tienda</h2>
    <div class="mt-6">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div
          v-for="product in products"
          :key="product.id"
          class="rounded-lg relative bg-white"
        >
          <router-link
            :to="{ name: 'productsDetail', params: { id: product.id } }"
          >
            <img
              :src="getImage(product)"
              alt=""
              class="rounded-t-lg h-72 w-full object-contain object-center bg-white"
            />
          </router-link>

          <div class="w-full rounded-b-lg px-4 pt-4 pb-16">
            <p class="font-medium">{{ product.name }}</p>
            <p class="font-medium text-success-500">
              {{ integerToCurrency(product.unit_price) }}
            </p>
            <p class="text-sm">{{ product.description }}</p>
          </div>

          <button
            v-if="product.stock > 0"
            class="absolute bottom-4 left-4 right-4 w-auto primary-button"
            @click="$store.dispatch('addToCart', product)"
          >
            Agregar al Carrito
          </button>

          <div v-else class="absolute bottom-4 left-4 right-4 text-error-500">Producto no disponible</div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="flex w-full h-full items-center">
    <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
  </div>
</template>

<script>
import api from "@/api";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Products",

  data() {
    return {
      products: null,
      loading: false,
      defaultImage: require("@/assets/paw.png"),
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "products");

    this.loadProducts();
  },

  methods: {
    integerToCurrency,

    async loadProducts() {
      this.loading = true;

      try {
        this.products = await api.resources.getProducts();
        this.products.forEach((product) => {
          product.quantity = 1;
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getImage(product) {
      if (!product.image_url) {
        return this.defaultImage;
      }

      return product.image_url;
    },
  },
};
</script>